import { useSyncExternalStore } from "react"

function subscribe(listener: () => void): () => void {
  window.addEventListener("online", listener)
  window.addEventListener("offline", listener)
  return () => {
    window.removeEventListener("online", listener)
    window.removeEventListener("offline", listener)
  }
}

function getSnapshot(): boolean {
  return navigator.onLine
}

/**
 * Есть ли связь по мнению браузера.
 *
 * Мнение это грубое: navigator.onLine врёт при живом Wi-Fi без интернета. Поэтому оно
 * здесь только как быстрый сигнал — окончательное состояние полосы «Нет связи» ставит
 * сорвавшийся запрос (ApiProblem с кодом offline), у которого есть время последних данных.
 */
export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => true)
}
